import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SharedUiIconsModule } from '@planone/shared/ui-icons';
import { SharedUtilAutocompleteModule } from '@planone/shared/util-autocomplete';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';

import { AddressComponent } from './address/address.component';
import { BackToTopComponent } from './back-to-top/back-to-top.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ChipsListFormControlComponent } from './chips-list-form-control/chips-list-form-control.component';
import { ConfirmButtonComponent } from './confirm-button/confirm-button.component';
import { ContactExhibitorComponent } from './contact-exhibitor/contact-exhibitor.component';
import { ContactPersonComponent } from './contact-person/contact-person.component';
import { ContactPersonListComponent } from './contact-person-list/contact-person-list.component';
import { DownloadListComponent } from './download-list/download-list.component';
import { ExpandableChipListComponent } from './expandable-chip-list/expandable-chip-list.component';
import { ExpandableTextComponent } from './expandable-text/expandable-text.component';
import { FileVideoEmbedComponent } from './file-video-embed/file-video-embed.component';
import { FilterButtonComponent } from './filter-button/filter-button.component';
import { IconTextComponent } from './icon-text/icon-text.component';
import { ItemTeaserCardComponent } from './item-teaser-card/item-teaser-card.component';
import { LinkListComponent } from './link-list/link-list.component';
import { LoadingAnimationComponent } from './loading-animation/loading-animation.component';
import { LoadingAnimationCenteredComponent } from './loading-animation-centered/loading-animation-centered.component';
import { LocationLinkDirective } from './location/location-link.directive';
import { LocationComponent } from './location/location.component';
import { ModalComponent } from './modal/modal.component';
import { ModalBottomsheetComponent } from './modal-bottomsheet/modal-bottomsheet.component';
import { ModalBottomsheetHelper } from './modal-bottomsheet/modal-bottomsheet.helper';
import { MoreCardComponent } from './more-card/more-card.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { ProfilePictureComponent } from './profile-picture/profile-picture.component';
import { RadioInputBottomSheetComponent } from './radio-input-bottom-sheet/radio-input-bottom-sheet.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { ShareButtonsComponent } from './share-buttons/share-buttons.component';
import { ShareButtonsHelper } from './share-buttons/share-buttons.helper';
import { SimpleFormComponent } from './simple-form/simple-form.component';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import { TagListComponent } from './tag-list/tag-list.component';
import { TeaserTextComponent } from './teaser-text/teaser-text.component';
import { YoutubeVideoCookieConsentOverlayComponent } from './youtube-video-cookie-consent-overlay/youtube-video-cookie-consent-overlay.component';
import { YoutubeVideoEmbedComponent } from './youtube-video-embed/youtube-video-embed.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatChipsModule,
    MatIconModule,
    MatStepperModule,
    MatButtonModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatRadioModule,
    MatBottomSheetModule,
    MatMenuModule,
    SharedUtilPipelinesModule,
    SharedUiIconsModule,
    MatDialogModule,
    RouterModule,
    ShareButtonsModule,
    MatTooltipModule,
    MatCardModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    OverlayModule,
    SharedUtilAutocompleteModule,
  ],
  declarations: [
    TagListComponent,
    SimpleFormComponent,
    ChipsListFormControlComponent,
    FileVideoEmbedComponent,
    YoutubeVideoEmbedComponent,
    ContactPersonComponent,
    ContactPersonListComponent,
    ContactExhibitorComponent,
    ModalComponent,
    LocationComponent,
    LocationLinkDirective,
    ExpandableTextComponent,
    BackToTopComponent,
    ProfilePictureComponent,
    DownloadListComponent,
    LinkListComponent,
    RadioInputBottomSheetComponent,
    ShareButtonsComponent,
    SnackBarComponent,
    ModalBottomsheetComponent,
    BreadcrumbComponent,
    ItemTeaserCardComponent,
    IconTextComponent,
    TeaserTextComponent,
    YoutubeVideoCookieConsentOverlayComponent,
    AddressComponent,
    ExpandableChipListComponent,
    PaginatorComponent,
    SearchInputComponent,
    MoreCardComponent,
    FilterButtonComponent,
    LoadingAnimationComponent,
    LoadingAnimationCenteredComponent,
    ConfirmButtonComponent,
  ],
  exports: [
    TagListComponent,
    ChipsListFormControlComponent,
    FileVideoEmbedComponent,
    YoutubeVideoEmbedComponent,
    ContactPersonComponent,
    ContactPersonListComponent,
    ContactExhibitorComponent,
    ExpandableChipListComponent,
    ModalComponent,
    LocationComponent,
    LocationLinkDirective,
    ExpandableTextComponent,
    BackToTopComponent,
    ProfilePictureComponent,
    DownloadListComponent,
    LinkListComponent,
    ShareButtonsComponent,
    SnackBarComponent,
    ModalBottomsheetComponent,
    BreadcrumbComponent,
    ItemTeaserCardComponent,
    IconTextComponent,
    TeaserTextComponent,
    YoutubeVideoCookieConsentOverlayComponent,
    AddressComponent,
    PaginatorComponent,
    SearchInputComponent,
    MoreCardComponent,
    FilterButtonComponent,
    LoadingAnimationComponent,
    LoadingAnimationCenteredComponent,
    ConfirmButtonComponent,
  ],
  providers: [ShareButtonsHelper, ModalBottomsheetHelper],
})
export class SharedUiElementsModule {}
